export default __webpack_public_path__ + "files/65cf6ac5eb6a18cbf23e4eb6a273b094.jpg";